import styled from "styled-components";

export const BgStandardStyled = styled.div`
  .btn {
    border-radius: 24px;
    width: 100%;
    padding: 0px 20px;
    height: ${({ height }) => (height ? height : "40px")};
    background: ${({ theme, disabled }) =>
      disabled ? theme.COLORS.GRAY_1 : theme.COLORS.PURPLE_1};
    color: ${({ theme }) => theme.COLORS.WHITE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
    cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  }

  .theme_cancel {
    .btn {
      background: ${({ theme }) => theme.COLORS.GRAY_1};
      color: ${({ theme }) => theme.COLORS.WHITE_1};
    }
  }

  .theme_red {
    .btn {
      background: ${({ theme }) => theme.COLORS.RED_1};
      color: ${({ theme }) => theme.COLORS.WHITE_1};
    }
  }

  .theme_stadard_btn {
  }

  .theme_standard_border {
    .btn {
      border: 1px solid ${({ theme }) => theme.COLORS.PURPLE_1};
      background: ${({ theme }) => theme.COLORS.WHITE_1};
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      height: ${({ height }) => (height ? height : "40px")};
    }
  }

  .theme_bosendorfer {
    .btn {
      border: 1px solid ${({ theme }) => theme.COLORS.GOLD_2};
      border-radius: 0px;
      background: unset;
      color: ${({ theme }) => theme.COLORS.GOLD_2};
      font-size: ${({ theme }) => theme.FONT.SIZE.S18};
      font-family: ${({ theme }) =>
        theme.FONT.STYLE.GLACIAL_INDIFFERENCE_REGULAR};
    }
  }

  .theme_white_purple {
    .btn {
      border: 1px solid ${({ theme }) => theme.COLORS.PURPLE_1};
      background: none;
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_SEMIBOLD};
      height: ${({ height }) => (height ? height : "40px")};
    }
  }

  .theme_white_red {
    .btn {
      border: 1px solid ${({ theme }) => theme.COLORS.RED_1};
      background: none;
      color: ${({ theme }) => theme.COLORS.RED_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_SEMIBOLD};
      height: ${({ height }) => (height ? height : "40px")};
    }
  }

  .theme_none_border {
    .btn {
      border: none;
      background: transparent;
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_SEMIBOLD};
      height: ${({ height }) => (height ? height : "40px")};
      .prefix_label {
      }
      .label_wrap {
        text-decoration: underline;
      }
    }
  }
`;
